<template>
  <div :id="field" class="inline-block multy-select">
      <label v-if="sel.length!=0" class="custom-label">{{text}}</label>
    <md-button :class="{ 'active-btn' : type}" md-menu-trigger @click="open" class="button-text">
      <template v-if="!type">
        <span class="contain-text" v-if="mdSelectedValue && mdSelectedValue.length>0">
          <span v-for="(item, index) in mdSelectedValue" :key="index">
            <template v-if="mdSelectedValue.length != index+1">{{item.name}}, </template>
            <template v-else>{{item.name}}</template>
          </span>
        </span>
        <span v-else>
          <template v-if="radio">{{ radio_val==1 ? $tc('general.lmt', 1) : $tc('general.store_agent', 1) }}</template>
          <template v-else>
            {{text}}
            <span v-if="!notAll">: All</span>
          </template>
        </span>
        <i class="fas fa-chevron-down pl-1"></i>
      </template>
      <span class="primary-color weight-500" v-else>
        {{text}}
        <md-icon class="primary-color">add</md-icon>
      </span>
    </md-button>
    <span @click="remove" class="d-inline-block ml-1 mr-2 remove-filter" v-if="filters">
      <md-icon class="color-fff">clear</md-icon>
    </span>
    <div>
      <div
        @focus="handleFocus"
        @focusout="handleFocusOut"
        tabindex="5"
        v-show="display"
        class="select-filter"
      >
        <div v-if="radio&&val">
          <md-radio
            v-for="(item, index) in values"
            :key="index"
            @change="$emit('r-update', [item.id, field]);"
            class="d-flex md-primary"
            v-model="radio_val"
            :value="item.id"
          >{{item.name}}</md-radio>
        </div>
        <div v-if="!radio">
          <div class="px-3 pt-1">
            <md-field>
              <label>Search</label>
              <md-input v-on:input="search" v-model="searchQuery"></md-input>
              <md-icon>search</md-icon>
            </md-field>
          </div>
          <my-table
            :object="object"
            :type="type"
            :filter="values?false:true"
            v-if="values||filter_values"
            @select="onSelect"
            @unselect="onUnselect($event)"
            :values="filter_values?filter_values:values"
            :name="field"
            :setvalues="setvalues"
          />
        </div>
        <div v-else-if="!val">
          <md-radio
            @change="$emit('r-update', [1, field]);"
            class="d-flex md-primary"
            v-model="radio_val"
            value="1"
          >{{ $tc('general.lmt', 1) }}</md-radio>
          <md-radio
            @change="$emit('r-update', [2, field]);"
            v-model="radio_val"
            value="2"
            class="d-flex md-primary"
          >{{ $tc('general.store_agent', 1) }}</md-radio>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyTable from "./Table";
export default {
  components: { "my-table": MyTable },
  props: [
    "values",
    "text",
    "field",
    "type",
    "str",
    "object",
    "filters",
    "accounts",
    "radio",
    "select",
    "val",
    "notAll",
    "afilters",
    "setvalues",
    "locale"
  ],
  data() {
    return {
      display: false,
      radio_val: "1",
      selected: [],
      searchQuery: "",
      mdSelectedValue: [],
      filter_values: "",
      ids: [],
      sel: []
    };
  },
  created() {
    this.mdSelectedValue = this.setvalues;
    if(this.field == 'banks' && this.mdSelectedValue) {
        this.sel = this.mdSelectedValue;
    }
    if (this.filters) {
      this.loadData();
    }
    Event.$on("remove", data => {
      let tmp = [];
      this.mdSelectedValue.forEach(element => {
        if (element.name != data) tmp.push(element);
      });
      this.mdSelectedValue = tmp;
    });
    Event.$on("clear-filters", () => {
      this.mdSelectedValue = [];
    });
    Event.$on("close-filters", data => {
      if (data != this.field) {
        this.display = false;
      }
    });
  },
  mounted() {
    Event.$on("filter-load", data => {
      if (data[1] != this.field) {
        if (this.field == "bank_ids") {
          this.filter_values = data[0].banks;
        } else if (this.field == "lmt_ids") {
          this.filter_values = data[0].lmts;
        } else if (this.field == "agent_ids") {
          this.filter_values = data[0].agents;
        } else if (this.field == "bank_account_ids") {
          this.filter_values = data[0].bank_accounts;
        } else {
          if (data[0].filters) {
            if (data[0].filters[this.field]) {
              this.filter_values = [];
              data[0].filters[this.field].items.forEach(element => {
                this.filter_values.push(element.name);
              });
            }
          }
        }
      }
    });
  },
  methods: {
    loadData(q = 1, search = 0) {
      let col = "";
      let d = 1;
      if (this.field == "bank_ids") {
        col = "banks";
      } else if (this.field == "lmt_ids") {
        col = "lmts";
      } else if (this.field == "agent_ids") {
        col = "agents";
      } else if (this.field == "bank_account_ids") {
        col = "bank_accounts";
      } else {
        col = this.field;
        d = 0;
      }

      let tmp = {};
      if (!q) {
        tmp.column = col;
        tmp.additional = this.$route.query.filters
          ? JSON.parse(this.$route.query.filters)
          : "";
        tmp.field = tmp;
      } else {
        tmp = q;
      }

      axios
        .get("/reports/filters-all", { params: { ...tmp } })
        .then(({ data }) => {
          if (d) {
            this.filter_values = data[col];
          } else {
            if (col != "filters") {
              if (data.filters && data.filters[col]) {
                this.filter_values = [];
                data.filters[col].items.forEach(element => {
                  this.filter_values.push(element.name);
                });
              }
            }
          }
          Event.$emit("filter-load", [data, this.field]);
        });
    },
    search() {
      if (this.locale) {
        this.local_search();
        return;
      }
      let col = "";
      let d = 1;
      if (this.field == "bank_ids") {
        col = "banks";
      } else if (this.field == "lmt_ids") {
        col = "lmts";
      } else if (this.field == "agent_ids") {
        col = "agents";
      } else if (this.field == "bank_account_ids") {
        col = "bank_accounts";
      } else {
        col = this.field;
        d = 0;
      }
      let tmp = {};
      tmp.column = col;
      tmp.term = this.searchQuery;
      tmp.additional = this.$route.query.filters
        ? JSON.parse(this.$route.query.filters)
        : "";

      //update the router params
      this.$router
        .push({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            filters: this.$route.query.filters,
            fields: JSON.stringify(tmp)
          }
        })
        .catch(err => {});

      let q = { ...this.$route.query, fields: JSON.stringify(tmp) };

      q.fields = JSON.parse(q.fields);
      q.fields = {
        ...q.fields,
        additional: tmp.additional,
        filters: {
          bank: q.bank_ids ? Object.values(JSON.parse(q.bank_ids)) : "",
          lmt: q.lmt_ids ? Object.values(JSON.parse(q.lmt_ids)) : "",
          agent: q.agent_ids ? Object.values(JSON.parse(q.agent_ids)) : "",
          bank_accounts: q.bank_account_ids
            ? Object.values(JSON.parse(q.bank_account_ids))
            : ""
        }
      };
      q.fields = JSON.stringify(q.fields);
      q.additional = JSON.stringify(q.additional);
      this.loadData(q, 1);
    },
    open() {
      this.display = !this.display;
      Event.$emit("close-filters", this.field);
    },
    remove() {
      Event.$emit("remove", this.field);
      this.mdSelectedValue = [];
      this.$emit("update", [[], this.field]);
    },
    onUnselect(id) {
      if (!this.filters) {
        this.selected = this.selected.filter(el => el.id != id);
        this.sel = this.sel.filter(el => el.id != id);
      } else {
        this.selected = this.selected.filter(el => el.name != id);
        this.sel = this.sel.filter(el => el.name != id);
      }
      
      const index = this.ids.indexOf(id);
      if (index > -1) {
        this.ids.splice(index, 1);
      }

      this.onSelect(this.selected);
    },
    //a value has been selected in this filter
    onSelect(items) {
      //store the selected values
      this.selected = this.selected.concat(items);

      this.selected.forEach(element => {
        if (!this.filters) {
          if (!this.ids.includes(element.id)) {
            this.ids.push(element.id);
            this.sel.push(element);
          }
        } else {
          if (!this.ids.includes(element.name)) {
            this.ids.push(element.name);
            this.sel.push(element);
          }
        }
      });

      let f = {};

      if (this.field == "filters") {
        items.forEach(element => {
          if (element.name == "all") {
            f = this.afilters;
            //delete f.all;
          } else {
            if (element.name != "amount") f[element.name] = "";
          }
        });

        this.$router
          .push({
            path: this.$route.path,
            query: { ...this.$route.query, filters: JSON.stringify(f) }
          })
          .catch(err => {});
      }

      let tmp = {};
      let add = {};
      tmp.column = this.field;
      tmp.additional = this.$route.query.filters
        ? { ...f, ...JSON.parse(this.$route.query.filters) }
        : f;

      //update the router params
      this.$router
        .push({
          path: this.$route.path,
          query: { ...this.$route.query, fields: JSON.stringify(tmp) }
        })
        .catch(err => {});

      if (this.type) {
        this.$emit("update", [this.sel, this.field]);
      }

      //check if the selected value has changed since last time
      //compare with JSON.stringify since the data is arrays
      if (JSON.stringify(this.mdSelectedValue) != JSON.stringify(items)) {
        //if the data has changed , inform the parent component and share the data and key

        this.$emit("update", [this.sel, this.field]);

        //update the stored data
        this.mdSelectedValue = items;
      }

      let q = { ...this.$route.query, fields: JSON.stringify(tmp) };

      q.fields = JSON.parse(q.fields);
      q.fields = {
        ...q.fields,
        term: this.searchQuery,
        additional: tmp.additional,
        filters: {
          bank: q.bank_ids ? Object.values(JSON.parse(q.bank_ids)) : "",
          lmt: q.lmt_ids ? Object.values(JSON.parse(q.lmt_ids)) : "",
          agent: q.agent_ids ? Object.values(JSON.parse(q.agent_ids)) : "",
          bank_accounts: q.bank_account_ids
            ? Object.values(JSON.parse(q.bank_account_ids))
            : ""
        }
      };
      q.fields = JSON.stringify(q.fields);
      q.additional = JSON.stringify(q.additional);

      this.loadData(q);
    },
    local_search() {
      if (this.searchQuery) {
        //return only the values that match the search string
        this.filter_values = this.values.filter(item => {
          return item.name
            .toUpperCase()
            .startsWith(this.searchQuery.toUpperCase());
        });
      } else {
        this.filter_values = this.values;
      }
    },

    //on focus display the select box
    handleFocus() {
      this.display = true;
    },

    //hide the select box on focus out
    handleFocusOut() {
      // this.display = false;
    }
  },
  computed: {
    //property used for searching
    filtered() {
      let tmp_val = this.values;

      if (this.filters) {
        tmp_val = [];
        let i = 0;
        this.filter_values.forEach(element => {
          tmp_val.push({ id: i++, name: element });
        });
        return tmp_val;
      }

      if (this.searchQuery) {
        //return only the values that match the search string
        return tmp_val.filter(item => {
          return item.name
            .toUpperCase()
            .startsWith(this.searchQuery.toUpperCase());
        });
      } else {
        //if no searchQuery has been set, return all the data
        return tmp_val;
      }
    },

    //returns the list of selected values in this selectbox
    SelectedValue() {
      if (this.type) {
        let tmp = [];

        this.mdSelectedValue.forEach(element => {
          tmp.push(element.name);
        });
        return this.values.filter(item => {
          return tmp.includes(item.name);
        });
      }
      // if select box is for the default filters like bank, lmt...
      if (!this.filters) {
        //find if the url contains this field
        let tmp = [];

        this.mdSelectedValue.forEach(element => {
          tmp.push(element[this.object]);
        });

        return this.values.filter(item => {
          return tmp.includes(item[this.object]);
        });
      } else {
        return this.mdSelectedValue;
        /* else the filter for the extra filters
        let f = this.$route.query.filters
          ? JSON.parse(this.$route.query.filters)
          : {};

        if (f && f[this.field]) {
          return this.values.filter(item => {
            return f[this.field].includes(item.name);
          });
        } else {
          return [];
        }
        */
      }
    }
  }
};
</script>
